import Vue from 'vue'
import Vuetify from 'vuetify'
import '@/styles/index.scss'
import ICONS from '@/constants/icon'

Vue.use(Vuetify, {
  iconfont: 'md',
  icons: ICONS,
  theme: {
    primary: '#2196F3',
    success: '#81C772',
    notify: '#f1336f'
    // info: '#ffaa2c',
    // error: '#f83e70'
  }
})



// WEBPACK FOOTER //
// ./src/plugins/vuetify.js